module.exports = __webpack_public_path__ + "img/img2_4.835dc7ac.jpeg";